import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { I18nModule } from "src/app/i18n.module";
import { DateIntervalSelectorComponent } from "./date-interval-selector.component";

@NgModule({
  declarations: [DateIntervalSelectorComponent],
  imports: [CommonModule, I18nModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatDatepickerModule],
  exports: [DateIntervalSelectorComponent],
})
export class DateIntervalSelectorModule {}
